export default () => ({
  statistics: [],
  errors: {}
})



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/overview/resources/data.js